import React from "react";
import { connect } from "react-redux";
import {
  clearSiteRoutesCache,
  updateLegacySessionKey,
} from "../../store/actions";
import { Link } from "react-router-dom";
import {
  pullCampaignOffices,
  pullCampaignScripts,
  pullCampaignSiteCanvasses,
  updateOrCreateSiteCanvass,
} from "../../store/api/calls";
import { siteCanvassEditCreateForm } from "../../utils/forms/formFields";

import NavBaseTemplate from "../templates/NavBaseTemplate";
import BaseForm from "../theme/forms/BaseForm";
import DataTable from "../theme/tables/DataTable";
import BaseModal from "../theme/modals/BaseModal";
import FeedbackTile from "../theme/modals/FeedbackTile";
import Moment from "moment";

class SiteCanvassScreen extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      editModalOpen: false,
      deleteModalOpen: false,
      editingInstance: {},
      feedbackTileVisibile: true,
      // feedbackTileColor: ,
      section: "siteroutes",
    };

    this.formInputs = siteCanvassEditCreateForm;
  }

  componentDidMount() {
    this.handleMountOrCampaignUpdate();
  }

  componentDidUpdate(prevProps) {
    if (this.props.focusedCampaign.id !== prevProps.focusedCampaign.id) {
      this.handleMountOrCampaignUpdate();
    }
  }

  handleMountOrCampaignUpdate = () => {
    pullCampaignSiteCanvasses()
      .then(() => pullCampaignOffices())
      .then(() => pullCampaignScripts())
      .then(() => this.populateCreateEditForm());
  };

  populateCreateEditForm(creating = false) {
    const offices = [{ value: null, display: "" }];
    this.props.campaignOffices.forEach((d) => {
      offices.push({ value: d.id, display: d.name });
    });

    const scripts = [{ value: null, display: "" }];
    this.props.campaignScripts.forEach((d) => {
      scripts.push({ value: d.id, display: d.name });
    });

    this.formInputs = [
      {
        type: "text",
        title: "Name",
        dataKey: "name",
        placeholder: "Use something descriptive",
      },
      {
        type: "select",
        title: "Office",
        dataKey: "office",
        options: offices,
      },
      {
        type: "select",
        title: "Script",
        dataKey: "script",
        options: scripts,
      },
    ];
  }

  _filterKeysForDataTable() {
    return this.props.siteCanvasses.map((d) => {
      // get the office and script or set up a default object to prevent the build from failing.
      let office = (this.props.campaignOffices &&
        this.props.campaignOffices.find(
          (office) => office.id === d.office
        )) || { name: "" };
      let script = (this.props.campaignScripts &&
        this.props.campaignScripts.find(
          (script) => script.id === d.script
        )) || { name: "" };
      return {
        name: (
          <Link
            to={`/sitecanvass/${d.id}`}
            onClick={this.props.clearSiteRoutesCache}
          >
            <a>{d.name}</a>
          </Link>
        ),
        _name: d.name,
        office: office.name,
        script: script.name,
        created_on: new Moment(d.created_at).format("MM/DD/YY"),
        _created_on: new Moment(d.created_at),
        _data: d,
      };
    });
  }

  onOpenEditModal = (modelInstance = {}) => {
    this.buildInputsWithPrepopulatedFields(modelInstance);
    this.setState({ editModalOpen: true, editingInstance: modelInstance });
  };

  onCloseEditModal = () => {
    this.setState({ editModalOpen: false, editingInstance: {} });
  };

  onOpenDeleteModal = (modelInstance = {}) => {
    this.setState({ deleteModalOpen: true, editingInstance: modelInstance });
  };

  onCloseDeleteModal = () => {
    this.setState({ deleteModalOpen: false, editingInstance: {} });
  };

  buildInputsWithPrepopulatedFields = (modelInstance) => {
    this.formInputs.forEach((d) => {
      d.value = modelInstance[d.dataKey];
    });
  };

  handleUpdateCreateSubmission = (data) => {
    const id = this.state.editingInstance.id;
    const campaign = this.props.focusedCampaign.id;
    if (id) data = { ...data, id };

    data = { ...data, campaign };
    updateOrCreateSiteCanvass(data).then(this.onCloseEditModal());
  };

  handleRemoveSubmission = () => {
    const id = this.state.editingInstance.id;
    const data = { is_active: false, id };

    updateOrCreateSiteCanvass(data).then(this.onCloseDeleteModal());
  };

  render() {
    return (
      <NavBaseTemplate>
        <div className="button-table-top-wrapper">
          <a className="button" onClick={this.onOpenEditModal}>
            + Create Site Canvass
          </a>
        </div>
        <DataTable
          data={this._filterKeysForDataTable() || []}
          title="Site Canvasses"
          actions={[
            {
              title: "edit",
              icon: "fa-edit",
              action: (modelInstance) => this.onOpenEditModal(modelInstance),
            },
            {
              title: "delete",
              icon: "fa-minus-square",
              action: this.onOpenDeleteModal,
            },
          ]}
        />

        <FeedbackTile
          text={
            <div>
              <i
                className=" fas fa-asterisk fa-spin"
                style={{ marginRight: "15px" }}
              />
              Loading...
            </div>
          }
          visible={this.props.loading}
        />

        {/*use feedback tile icon, text, state*/}
        <FeedbackTile
          text={
            <div>
              <i className=" fas fa-asterisk" style={{ marginRight: "15px" }} />
            </div>
          }
          visible={this.state.showSuccess}
        />

        <BaseModal
          open={this.state.editModalOpen}
          onClose={this.onCloseEditModal}
          center
        >
          <BaseForm
            inputs={this.formInputs}
            onCancel={this.onCloseEditModal}
            onSubmit={this.handleUpdateCreateSubmission}
          />
        </BaseModal>

        {/*Delete Modal*/}

        <BaseModal
          open={this.state.deleteModalOpen}
          onClose={this.onCloseDeleteModal}
          center
        >
          <div className="modal-internal-wrapper">
            <p>
              Are you sure you want to remove the sitecanvass{" "}
              <b>{this.state.editingInstance.name}</b>?
            </p>
            <div className="button-wrapper">
              <div className="button" onClick={this.handleRemoveSubmission}>
                Remove
              </div>
              <div
                className="button button-outline"
                onClick={this.onCloseDeleteModal}
              >
                Cancel
              </div>
            </div>
          </div>
        </BaseModal>
      </NavBaseTemplate>
    );
  }
}

const mapStateToProps = (state) => ({
  campaigns: state.campaigns?.data,
  focusedCampaign: state.session.focusedCampaign,
  siteCanvasses: state.siteCanvasses.data,
  loading: state.siteCanvasses.loading,
  error: state.siteCanvasses.error,
  campaignOffices: state.offices.data,
  campaignScripts: state.scripts.data,
  is_admin: state.permissions.is_admin,
});

//tHIS NEEDS tO MOVE tO tHE tEMPLAtE SCREEN!
const mapDispatchToProps = (dispatch) => ({
  updateLegacySessionKey: (key) => dispatch(updateLegacySessionKey(key)),
  clearSiteRoutesCache: () => dispatch(clearSiteRoutesCache()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SiteCanvassScreen);
